import React, { useState } from 'react';
import './DemoSession.css';

interface DemoSessionProps {
  onSubmit: (formData: any) => Promise<void>;
}

const DemoSession: React.FC<DemoSessionProps> = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    parentName: '',
    childName: '',
    email: '',
    phone: '',
    preferredTrack: '',
    preferredTime: '',
    message: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form data being submitted:', formData);
    // Call the onSubmit prop to send data to Google Sheets
    onSubmit(formData);
  };

  return (
    <section className="demo-session-section">
      <div className="container">
        <div className="demo-header">
          <h1>Book a Free Demo Session</h1>
          <p>Experience the IIITD-IC Summer Camp 2026 before you decide. Schedule a free demo session with our expert instructors.</p>
        </div>
        
        <div className="demo-content">
          <div className="demo-form-container">
            <form className="demo-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="parentName">Parent/Guardian Name</label>
                <input 
                  type="text" 
                  id="parentName" 
                  name="parentName" 
                  placeholder="Enter your full name" 
                  required 
                  value={formData.parentName}
                  onChange={handleChange}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="childName">Child's Name</label>
                <input 
                  type="text" 
                  id="childName" 
                  name="childName" 
                  placeholder="Enter child's name" 
                  required 
                  value={formData.childName}
                  onChange={handleChange}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  placeholder="Enter email address" 
                  required 
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input 
                  type="tel" 
                  id="phone" 
                  name="phone" 
                  placeholder="Enter 10-digit phone number" 
                  pattern="[0-9]{10}" 
                  required 
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="preferredTrack">Preferred Track</label>
                <select 
                  id="preferredTrack" 
                  name="preferredTrack" 
                  required
                  value={formData.preferredTrack}
                  onChange={handleChange}
                >
                  <option value="">Choose a track</option>
                  <option value="robotics">Robotics + IoT + AI</option>
                  <option value="drone">Drone Tech + Aero Modelling</option>
                  <option value="both">Interested in Both</option>
                </select>
              </div>
              
              <div className="form-group">
                <label htmlFor="preferredTime">Preferred Time Slot</label>
                <select 
                  id="preferredTime" 
                  name="preferredTime" 
                  required
                  value={formData.preferredTime}
                  onChange={handleChange}
                >
                  <option value="">Choose a time slot</option>
                  <option value="3-4">3:00 PM - 4:00 PM</option>
                  <option value="4-5">4:00 PM - 5:00 PM</option>
                  <option value="5-6">5:00 PM - 6:00 PM</option>
                  <option value="6-7">6:00 PM - 7:00 PM</option>
                  <option value="7-8">7:00 PM - 8:00 PM</option>
                  <option value="8-9">8:00 PM - 9:00 PM</option>
                </select>
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Questions or Comments (Optional)</label>
                <textarea 
                  id="message" 
                  name="message" 
                  placeholder="Any questions or specific areas of interest?" 
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
              </div>
              
              <button type="submit" className="btn btn-primary submit-btn">
                Book Free Demo
              </button>
            </form>
          </div>
          
          <div className="demo-benefits">
            <h2>Why Book a Demo Session?</h2>
            <div className="benefits-grid">
              <div className="benefit-item">
                <div className="benefit-icon">👁️</div>
                <h3>See Our Curriculum</h3>
                <p>Get a first-hand look at our innovative curriculum and teaching methods.</p>
              </div>
              
              <div className="benefit-item">
                <div className="benefit-icon">🧪</div>
                <h3>Try the Technology</h3>
                <p>Let your child experience our cutting-edge tech equipment before signing up.</p>
              </div>
              
              <div className="benefit-item">
                <div className="benefit-icon">👨‍🏫</div>
                <h3>Meet Our Mentors</h3>
                <p>Interact with our expert mentors and ask any questions you may have.</p>
              </div>
              
              <div className="benefit-item">
                <div className="benefit-icon">🧩</div>
                <h3>Gauge Interest Level</h3>
                <p>See if your child connects with the material before committing to the full camp.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DemoSession;
